import { readonly, shallowRef } from "vue";
import { useI18n } from "vue-i18n";

// share value
let solutionFilterOptions = readonly([]);

/**
 * Add here any shared data for search solutions
 * @returns 
 */
export function useSearchSolutions(){

	// define only one time
	if(solutionFilterOptions.length == 0){
		const i18n = useI18n();

		solutionFilterOptions = readonly([
			{label: i18n.t('filterSolutionOptions.all', 'Tutte le soluzioni'), value: 'all'},
			{label: i18n.t('filterSolutionOptions.frecce'), value: 'frecce'},
			{label: i18n.t('filterSolutionOptions.regionali'), value: 'regionali'},
			{label: i18n.t('filterSolutionOptions.intercityFilter'), value: 'intercityFilter'},
			{label: i18n.t('filterSolutionOptions.intercityNotte'), value: 'intercityNotte'},
			{label: i18n.t('filterSolutionOptions.link'), value: 'link'},
			{label: i18n.t('filterSolutionOptions.globalPass'), value: 'globalPass'},
		]);
	}
	
	return {
		solutionFilterOptions
	};
}